import { tableHooks } from "components/Table"
import { alerts } from "keys"
import { useCallback, useMemo } from "react"
import { useDispatch } from "react-redux"
import { actions } from "store"

const useLearningGroupTableColumns = () => {
    const dispatch = useDispatch()

    const editLearningGroup = useCallback((learningGroup) => {
        dispatch(actions.setAlerts({
            key: alerts.addLearningGroup,
            value: { open: true, props: learningGroup }
        }))
    }, [])

    const editCell = tableHooks.useEditCell({
        action: editLearningGroup
    })

    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: "שם הקבוצה",
            },
            {
                accessorKey: 'student_len',
                header: "מספר תלמידים",
            },
            editCell
        ], []
    )

    return columns
}

export default useLearningGroupTableColumns